module.exports = __webpack_public_path__ + "img/3_treasure chest3.67659c1e.jpg";